import { createI18n } from "vue-i18n";
import { defaultLocale, languages } from "~/assets/locale/locale.js";

export default defineNuxtPlugin((nuxtApp) => {
    // Получаем куку 'lang' (работает и на сервере, и на клиенте)
    const langCookie = useCookie('lang')
    const route = useRoute()

    // Приоритет: параметр lang в URL -> кука -> дефолт
    let locale = route.query.lang || langCookie.value || defaultLocale

    const i18n = createI18n({
        legacy: false,
        locale: locale,
        fallbackWarn: false,
        missingWarn: false,
        fallbackLocale: 'ru',
        pluralRules: {
            ru(choice, choicesLength, originalRule) {
                if (choicesLength !== 3) return originalRule(choice, choicesLength)
                const count = Math.abs(choice)
                const lastDigit = count % 10
                const lastTwoDigits = count % 100
                if (lastDigit === 1 && lastTwoDigits !== 11) return 0
                if (lastDigit >= 2 && lastDigit <= 4 && (lastTwoDigits < 12 || lastTwoDigits > 14)) return 1
                return 2
            }
        },
        messages: languages,
        warnHtmlMessage: false
    });

    nuxtApp.vueApp.use(i18n)

    return {
        provide: {
            i18n: i18n
        }
    }
})
